import { __makeTemplateObject } from "tslib";
import { styled } from '../../../foundation';
export var StyledPresenceWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  ", ": 14%;\n  ", ": 14%;\n  transform: translate(\n    ", "50%,\n    ", "50%\n  );\n  transform-origin: 100% 100%;\n"], ["\n  position: absolute;\n  ", ": 14%;\n  ", ": 14%;\n  transform: translate(\n    ", "50%,\n    ", "50%\n  );\n  transform-origin: 100% 100%;\n"])), function (_a) {
    var horizontal = _a.horizontal;
    return horizontal;
}, function (_a) {
    var vertical = _a.vertical;
    return vertical;
}, function (_a) {
    var horizontal = _a.horizontal;
    return (horizontal === 'right' ? '' : '-');
}, function (_a) {
    var vertical = _a.vertical;
    return (vertical === 'bottom' ? '' : '-');
});
var templateObject_1;
